import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './footer.component';
import { StickyBottomComponent } from './sticky-bottom/sticky-bottom.component';
import { TabsetCollapseComponent } from './tabset-collapse/tabset-collapse.component';
import { ToolsComponent } from './tools/tools.component';

@NgModule({
  declarations: [FooterComponent, StickyBottomComponent, TabsetCollapseComponent, ToolsComponent],
  exports: [FooterComponent],
  imports: [SharedModule],
  providers: [],
})
export class FooterModule {}



// WEBPACK FOOTER //
// ./ts/app/footer/footer.module.ts